<template>
	<div>
		<div class="wrapper wrapper-content animated fadeInRight">
			<div class="row">
				<div class="col-lg-12">
					<div class="ibox"  v-if="downloaded">
						<div class="ibox-content">
							<div>
								<div class="widget  p-lg text-center">
									<div class="m-b-md">
										<i class="fa fa-check-circle fa-4x"></i>
										<h1 class="m-xs">Sikeres</h1>
										<h3 class="font-bold no-margins">
											Letöltés
										</h3>
										<small>válassz műveletet:</small>
									</div>
								</div>
								<div class="row">
									<div class="col-6 text-center">
										<router-link to="/data-collection" class="btn btn-primary btn-lg" tag="button"><i class="fa fa-database fa-3x"></i><h3>Adatgyűjtés</h3></router-link>
									</div>
									<div class="col-6 text-center">
										<router-link to="/checking" class="btn btn-primary btn-lg" tag="button"><i class="fa fa-search fa-3x"></i><h3>Ellenőrzés</h3></router-link>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="vsm--header" style="min-height:120px;margin-bottom:50px;" v-else></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import appService from '../../apis/appService.js';
import moment from 'moment'
	
export default {
    name:  'tc26',
	data() {
        return {
			list: [],
			itemName: false,
			notfound: false,
			barcode: '',
			isRunning:false,
			msg:'',
		}
	},
	computed:{
		barcode_list_url(){
			return this.$store.state.barcode_list_url;
		},
		downloading(){
			return this.$store.state.downloading;
		},
		downloaded(){
			return this.$store.state.downloaded;
		},
		time(){
			return this.$store.state.time;
		},
		lszsz(){
			return this.$store.state.lszsz;
		},
		user(){			
			return this.$store.state.user;
		}
	},
	created(){
		if(this.user != null){
			appService.isWorkerOnBreak(this.user.project_id,this.lszsz,appService.getDeviceId())
			.then(response => {
				if(response.data.status == true){
					this.$store.commit('updateOnBreak',true);
					this.$router.push({path:'/break'});
				}
			});
		}
		this.$store.commit('updateSubTitle',null); 
	},
	mounted(){
		this.initializeBarcodeList();		
	},
	methods: {
		initializeBarcodeList(){
			this.$store.commit('updateDownloaded',false);
			this.$store.commit('updateDownloading',true);
			
			let response = appService.initializeBarcodeList(this.barcode_list_url);
			if(response == "1"){
				let currentdate = moment().format('YYYY-MM-DD HH:mm:ss');
				this.$store.commit('updateLastBarcodeListRefresh',currentdate);

				let backup_files = appService.getBackupFiles(this.user.project_id);
				if(backup_files.length > 0){
					this.$router.push({path:'/data-collection'});
				}
			}
		}
	},
	watch:{
        msg:  function (msgNew, msgOld) {
            console.log('new: %s, old: %s', msgNew, msgOld)
        },
		user: function (newUser, oldUser) {
			if(oldUser == null && newUser != null){
				appService.isWorkerOnBreak(this.user.project_id,this.lszsz,appService.getDeviceId())
				.then(response => {
					if(response.data.status == true){
						this.$store.commit('updateOnBreak',true);
						this.$router.push({path:'/break'});
					}
				});
			}
		}
    },
};
</script>
<style  scoped>
h3 {
    margin: 40px  0  0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0  10px;
}
a {
    color: #42b983;
}
.fs-2{font-size:1rem;}
</style>